import React from "react";
import { Link } from "react-router-dom";

const CoreComponent13 = ({ content3 }) => {
  return (
    <div className="container">
      <div className="row">
        {content3.map((val, i) => (
          <div key={i} className="col-12 ">
            <div className="row  d-flex align-items-center justify-content-between">
              <div className="col-lg-5">
                <h2 className="h2-heading lh-sm ">{val.title}</h2>

                <p className=" lh-base mb-1 py-3 mt-1" style={{ fontSize: 16 }}>
                  {val.desc}
                </p>
                <Link to="/request-quote">
                  <button className="h3-para px-4 py-2 rounded-5 btn-gradient text-white ">
                    Explore all offers{" "}
                  </button>
                </Link>
              </div>
              <div className="col-lg-7 ">
                <div className=" row  d-flex justify-content-evenly z-3  align-items-center custom-card-row">
                  {val.loops.map((val, i) => (
                    <div
                      key={i}
                      className={`col-md-5 col-11  bg-black my-4 p-4 rounded-4 ${val.line} position-relative `}
                      style={{ maxWidth: "", height: 370 }}
                    >
                      <img
                        src={val.icon}
                        alt=""
                        className=" m-0 "
                        style={{ width: 50, height: 50 }}
                      />
                      <h2 className="fs-5  lh-sm mt-3 pb-1 pt-2 text-white mt-2">
                        {val.title}
                      </h2>
                      <p
                        className="h3-para lh-sm text-white  "
                        style={{ opacity: 0.6, fontSize: 16 }}
                      >
                        {val.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoreComponent13;
